import { render } from "./ProjectMockup.vue?vue&type=template&id=3194ebbf&ts=true"
import script from "./ProjectMockup.vue?vue&type=script&lang=ts"
export * from "./ProjectMockup.vue?vue&type=script&lang=ts"

import "./ProjectMockup.vue?vue&type=style&index=0&id=3194ebbf&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__